// First Created — 22 Nov 2025
// Author — Atul Pandey
// Purpose — About Page for Eternity & Trinity (Modular, Hybrid Aesthetic)

import React from "react";
import EtHeader from "@/components/navigation/EtHeader";
import EtFooter from "@/components/navigation/EtFooter";

import EtAboutHero from "@/components/about/EtAboutHero";
import EtOriginStory from "@/components/about/EtOriginStory";
import EtProblemStatement from "@/components/about/EtProblemStatement";
import EtPhilosophy from "@/components/about/EtPhilosophy";
import EtEternityPractice from "@/components/about/EtEternityPractice";
import EtTrinityCompanion from "@/components/about/EtTrinityCompanion";
import EtTrinityFramework from "@/components/about/EtTrinityFramework";
import EtFounderNote from "@/components/about/EtFounderNote";
import EtAboutCTA from "@/components/about/EtAboutCTA";

// 23 Nov 2025
import EtAboutFounder from "@/components/about/EtAboutFounder";

// 30 Nov 2025
import EtNoCopyWrapper from "@/components/protection/EtNoCopyWrapper";

export default function EtAboutPage() {

  // First Created - 22 Nov 2025
  // Author - Atul Pandey
  // Purpose — About Page Sections - Eternity & Trinity
  // Updated - 23 Nov 2025 - Added EtAboutFounder section page
  // Updated - 30 Nov 2025 - Added EtNoCopyWrapper


  return (
    <div className="font-poppins">
      <EtHeader />

    <EtNoCopyWrapper>
        {/* Step 1 – Hero */}
        <EtAboutHero />

        {/* Step 2 – Origin Story */}
        <EtOriginStory />

        {/* Step 3 – Problem Statement */}
        <EtProblemStatement />

        {/* Step 4 – Philosophy */}
        <EtPhilosophy />

        {/* Step 5 – Eternity’s Advisory Practice */}
        <EtEternityPractice />

        {/* Step 6 – Trinity Companion */}
        <EtTrinityCompanion />

        {/* Step 7 – Trinity Framework */}
        <EtTrinityFramework />

        {/* Step 8 – Founder & Founder Note */}
        <EtAboutFounder />
        <EtFounderNote />
      </EtNoCopyWrapper>

      {/* Step 9 – CTA */}
      <EtAboutCTA />

      <EtFooter />
    </div>
  );
}